import { AuthAPI, AuthState } from '@/types/auth'
import { PermissionModal } from '../utils'

export default function convertAuthClient(apiResponse: AuthAPI): AuthState {
  const { client, access_token } = apiResponse

  console.log('convertAuthClient', apiResponse)
  const initialState: AuthState = {
    user: null,
    token: access_token,
    client: client,
    permissions: PermissionModal,
    isLoading: false
  }

  return initialState
}
